<template>
  <sb-panel
    collection="cta"
    :ctacollection="ctaProducts"
    class="sb-cta"
    :class="[
      products && products.length > 0 ? 'withProducts' : '',
      ctaProducts == 'similarProducts' && !silverdluxeDesktop
        ? 'ctaPortrait'
        : '',
      ctaProducts == 'similarProducts' ? 'similarCta' : '',
    ]"
    v-if="ctaOpen && products.length > 0"
    :closeButton="true"
  >
    <a class="ctaLink" @click="toggleAction">
      <header class="shopbox-header">
        <h2>{{ ctaHeading }}</h2>
        <h4>{{ ctaSubheading }}</h4>
      </header>
      <hr />
      <ul>
        <li v-for="(p, i) in products" :key="i">
          <img :src="p.imageUrl" :alt="p.name" />
        </li>
      </ul>
    </a>
  </sb-panel>
</template>
<script>
import sbPanel from "./partials/Panel.vue";
import { mapState } from "vuex";
export default {
  components: {
    sbPanel,
  },
  computed: {
    ...mapState([
      "ctaProducts",
      "ctaHeading",
      "ctaSubheading",
      "ctaOpen",
      "ctaTimer",
      "ctaAction",
      "similarProducts",
      "recentProducts",
      "crosssellProducts",
      "lastProductId",
      "c_page",
      "uuid",
      "client",
    ]),
    silverdluxeDesktop: function () {
      if (this.client == "silverdluxe" && !this.isMobile()) {
        return true;
      }
      return false;
    },
    products: function () {
      if (this.ctaProducts == "similarProducts") {
        return this.similarProducts;
      } else if (this.ctaProducts == "crosssellProducts") {
        return this.crosssellProducts;
      } else if (this.ctaProducts == "recentProducts") {
        return this.recentProducts;
      }

      return null;
    },
  },

  methods: {
    toggleSimilar() {
      if (this.lastProductId) {
        this.$emit("toggleSimilar", {
          sku: this.lastProductId,
          page: 1,
          toggle: true,
          reset: true,
          force: true,
        });
      } else {
        console.log("0");
        this.$store.commit("OPEN_PANEL", "similar");
      }
      this.$store.dispatch("emitEvent", {
        data: {
          page: this.c_page,
          productid: "",
          sbAction: `Clicked`,
          site: this.client,
          source: "SimilarCta",
          uuid: this.uuid,
        },
        headers: {},
        type: "sbaction",
      });
    },
    toggleCrosssell() {
      this.$emit("toggleCrosssell", {
        toggle: true,
        reset: true,
        force: true,
        page: 1,
      });
    },
    toggleRecent() {
      // if (this.recentProducts.length > 0) {
      //   this.$store.commit("OPEN_PANEL", "recent");
      // } else {
      this.$emit("toggleRecent", {
        toggle: true,
        reset: true,
        force: true,
        page: 1,
      });
      // }
      this.$store.dispatch("emitEvent", {
        data: {
          page: this.c_page,
          productid: "",
          sbAction: `Clicked`,
          site: this.client,
          source: "RecentCta",
          uuid: this.uuid,
        },
        headers: {},
        type: "sbaction",
      });
    },
    toggleAction() {
      this.$store.commit("CLOSE_PANEL_NO_EVENT", "cta");

      this[this.ctaAction]();
    },
    returnProducts() {
      if (this.ctaProducts) {
        return this[this.ctaProducts];
      } else {
        this.$store.commit("CLOSE_PANEL_NO_EVENT", "cta");
        return null;
      }
    },
  },
  watch: {
    ctaOpen: {
      handler() {
        if (this.ctaOpen) {
          // if (this.ctaOpen && this.products.length < 1) {
          //   this.$store.commit("CLOSE_PANEL_NO_EVENT", "cta");
          // }
          setTimeout(() => {
            if (this.ctaOpen) {
              this.$store.commit("CLOSE_CTA");
            }
          }, this.ctaTimer);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
#shopbox .sb-cta .shopbox-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  color: var(--shopbox-main);
  background: none !important;
  width: 100%;
  padding: 6px;
  box-sizing: border-box;
  border: none !important;
}
#shopbox .sb-cta .shopbox-header * {
  font-weight: normal;
  color: var(--shopbox-main) !important;
  text-transform: none;
  letter-spacing: normal;
  text-align: center;
  font-size: 26px !important;
}
#shopbox .sb-cta .shopbox-header h4 {
  font-size: 20px !important;
}
#shopbox .sb-cta {
  bottom: 84px !important;
  left: 16px !important;
  width: 340px;
  min-height: 60px;
  overflow: hidden;
  box-sizing: border-box;
  color: var(--shopbox-text-light) !important;
  cursor: pointer;
  transition: all 200ms ease-out;
  padding-top: 8px !important;
}
#shopbox .shopbox-right .sb-cta {
  right: 16px !important;
  left: unset !important;
}
#shopbox .sb-cta:hover {
  transform: translateY(-2px);
}
#shopbox .sb-cta hr {
  max-width: 40%;
  margin: 10px auto;
}
#shopbox .sb-cta .ctaLink {
  position: static;
}
#shopbox img {
  margin: 0;
  width: 98px !important;
  height: 98px !important;
  padding: 8px !important;
  object-fit: contain;
}
#shopbox ul {
  display: flex;
}
#shopbox li {
  flex-basis: 33%;
  flex-grow: 1;
}
#shopbox .sb-cta li:nth-of-type(n + 4) {
  display: none;
}
#shopbox .sb-cta {
  animation: bounce 0.4s infinite alternate;
  -webkit-animation: bounce 0.4s infinite alternate;
}
#shopbox .ctaPortrait {
  width: 60px !important;
  padding-bottom: 8px;
  animation: none;
}
@media (min-width: 768px) {
  /* #shopbox .ctaPortrait {
    background: none;
    border: none;
    box-shadow: none !important;
  } */
  #shopbox .ctaPortrait .shopbox-header {
    height: 50px !important;
    /* opacity: 0; */
  }
}
#shopbox .ctaPortrait hr {
  display: none;
}
#shopbox .ctaPortrait .shopbox-header {
  justify-content: flex-end;
  height: 32px;
  transition: all 200ms ease-out;
}
#shopbox .ctaPortrait:hover {
  background: var(--shopbox-background-light);
  box-shadow: 0 1px 6px 0 rgba(117, 141, 166, 0.45) !important;
}
#shopbox .ctaPortrait:hover .shopbox-header {
  opacity: 1;
}
#shopbox .ctaPortrait:hover img {
  box-shadow: none;
}

#shopbox .ctaPortrait .shopbox-header h2 {
  margin: 4px !important;
  font-size: 12px !important;
}
#shopbox .ctaPortrait ul {
  flex-direction: column;
}
#shopbox .ctaPortrait li {
  padding: 0 !important;
}
#shopbox .ctaPortrait.sb-cta img {
  padding: 0px !important;
  width: 43px !important;
  height: 43px !important;
  object-fit: contain;
  box-shadow: 0 1px 4px 0 rgba(117, 141, 166, 0.25);
  margin-bottom: 8px !important;
  border-radius: 6px;
  transition: all 200ms ease-out;
}
#shopbox li::marker {
  font-size: 0;
  display: none;
}
@keyframes bounce {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-4px);
  }
}
@-webkit-keyframes bounce {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-4px);
  }
}
</style>
